module.exports = __webpack_public_path__ + "img/mui-social.c5a2928d.png";